import clsx from 'clsx';
import React, {FC, ReactElement, ReactNode} from 'react';

import * as styles from './textSection.module.scss';


type Props = {
  title?: string,
  children: ReactNode,
} & (
  {
    image?: ReactElement,
    alignImage?: 'left' | 'right',
    forceFloatImage?: boolean,
  }
);


const TextSection: FC<Props> = ({children: text, title, image, alignImage, forceFloatImage}) => (
  <section className={styles.section}>
    {title && <h2 className={styles.title}>{title}</h2>}

    <div className={styles.content}>
      {image && (
        <div className={clsx(styles.image, alignImage && styles[alignImage], forceFloatImage && styles.forceFloat)}>
          {image}
        </div>
      )}

      <div className={styles.text}>{text}</div>
    </div>
  </section>
);


export default TextSection;
